import { render } from "./LInfoHome.vue?vue&type=template&id=04dddaf4&scoped=true&ts=true"
import script from "./LInfoHome.vue?vue&type=script&lang=ts"
export * from "./LInfoHome.vue?vue&type=script&lang=ts"

import "./LInfoHome.vue?vue&type=style&index=0&id=04dddaf4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dddaf4"]])

export default __exports__